import { useState } from 'react';


const s = {
  page: { minHeight: '100vh', backgroundColor: '#f5f5f3', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif' },
  card: { backgroundColor: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '8px', padding: '40px', width: '100%', maxWidth: '380px' },
  header: { marginBottom: '28px' },
  title: { fontSize: '18px', fontWeight: '700', color: '#1a1a1a', letterSpacing: '-0.3px', marginBottom: '4px' },
  subtitle: { fontSize: '12px', color: '#aaa', textTransform: 'uppercase', letterSpacing: '1px' },
  error: { backgroundColor: '#fdecea', color: '#c0392b', padding: '10px 14px', borderRadius: '6px', marginBottom: '16px', fontSize: '13px' },
  label: { display: 'block', fontSize: '12px', fontWeight: '500', color: '#666', marginBottom: '6px' },
  input: { width: '100%', padding: '9px 12px', border: '0.5px solid #e0e0e0', borderRadius: '6px', fontSize: '13px', outline: 'none', color: '#1a1a1a', marginBottom: '16px', boxSizing: 'border-box' },
  btn: { width: '100%', padding: '10px', backgroundColor: '#1a1a1a', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '500', cursor: 'pointer' },
  btnDisabled: { width: '100%', padding: '10px', backgroundColor: '#ccc', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '500' },
  back: { marginTop: '20px', textAlign: 'center', fontSize: '12px' },
  backLink: { color: '#aaa', textDecoration: 'none' },
};

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/admin/login', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ email, password })
});
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Login failed'); return; }
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin', JSON.stringify(data.admin));
      window.location.href = '/admin/dashboard';
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.header}>
          <h1 style={s.title}>Menu Board</h1>
          <p style={s.subtitle}>Admin Panel</p>
        </div>
        {error && <p style={s.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <label style={s.label}>Email</label>
          <input style={s.input} type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          <label style={s.label}>Password</label>
          <input style={s.input} type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          <button style={loading ? s.btnDisabled : s.btn} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p style={s.back}><a href="/" style={s.backLink}>Back to restaurant login</a></p>
      </div>
    </div>
  );
}


export default AdminLogin;
